module.exports = __webpack_public_path__ + "static/img/A19.01160283.jpg";